/**
 * formats a number into a string as a percentage to the decimal place of a decimal number
 * @method convertToPercentString
 * @param {Number} value - number to convert, ex 0.90459
 * @returns {String} - string percentage, ex '90.5%'
 */
const convertToPercentString = (value) => {
  return `${(value * 100).toFixed(1)}%`;
};

export default convertToPercentString;
